import styled from 'styled-components';
import React from 'react';
import { IconButton, IconButtonProps } from '@oneaudi/unified-web-components';
import {
  SYS_BREAKPOINT_2_XL,
  SYS_BREAKPOINT_LG,
  SYS_BREAKPOINT_MD,
  SYS_BREAKPOINT_SM,
  SYS_BREAKPOINT_XL,
  SYS_SPACE_FIXED_200,
  SYS_SPACE_FIXED_500,
  SYS_SPACE_FIXED_600,
  SYS_SPACE_RELATIVE_6_XL,
} from '@oneaudi/unified-web-common';
import { dynamicStyling, dynamicStylingHelper } from '@oneaudi/vtp-shared';
import { SYS_SPACE_RELATIVE_LG } from '@oneaudi/unified-web-alpha-common';

export const SearchWrapper = styled.div`
  display: grid;
  width: 100%;
  grid-template-columns: ${dynamicStylingHelper('88% auto', '100%')};
  gap: ${SYS_SPACE_FIXED_200};
  ${dynamicStyling({
    alpha: `
    margin-bottom: ${SYS_SPACE_RELATIVE_LG};
  `,
  })};

  @media (min-width: ${SYS_BREAKPOINT_SM}) {
    grid-template-columns: ${dynamicStylingHelper('89% auto', '100%')};
  }

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    grid-template-columns: ${dynamicStylingHelper('95% auto', '100%')};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    grid-template-columns: ${dynamicStylingHelper('85% auto', '100%')};
  }

  @media (min-width: ${SYS_BREAKPOINT_XL}) {
    grid-template-columns: ${dynamicStylingHelper('87% auto', '100%')};
  }

  @media (min-width: ${SYS_BREAKPOINT_2_XL}) {
    grid-template-columns: ${dynamicStylingHelper('91% auto', '100%')};
  }

  label {
    clip: rect(0 0 0 0);
    clip-path: inset(50%);
    height: 1px;
    overflow: hidden;
    position: absolute;
    white-space: nowrap;
    width: 1px;
  }
  gmp-place-autocomplete {
    padding: 0;
  }
`;

export const LocateMeButton = styled((props) => <IconButton {...props} />)<IconButtonProps>`
  min-width: 24px;
  max-width: 36px;
  min-height: 24px;
  max-height: 36px;
  background-color: rgba(154, 163, 177, 0);
  border: none;
  :disabled {
    box-shadow: none;
  }

  button {
    border: none;
    width: 100%;
  }

  /* locate-me icon and delete text */
  svg {
    flex: 1 0 24px;
  }
`;

export const QuickLocationFilterWrapper = styled.div`
  margin-bottom: ${dynamicStylingHelper(SYS_SPACE_FIXED_600, SYS_SPACE_FIXED_500)};

  @media (min-width: ${SYS_BREAKPOINT_MD}) {
    margin-bottom: ${dynamicStylingHelper(SYS_SPACE_RELATIVE_6_XL, SYS_SPACE_FIXED_500)};
  }

  @media (min-width: ${SYS_BREAKPOINT_LG}) {
    margin-bottom: ${dynamicStylingHelper(SYS_SPACE_FIXED_600, SYS_SPACE_FIXED_500)};
  }
`;
